import { render, staticRenderFns } from "./SubscriptionPayments.vue?vue&type=template&id=74691868&"
import script from "./SubscriptionPayments.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports